import {Injectable  } from '@angular/core';
import {Restaurant} from "../../model/restaurant";

import {Observable, Subject} from "rxjs";
import {Code} from "../../model/code";

import { AngularFireDatabase } from 'angularfire2/database';
import {InvitationCode} from "../../model/invitation-code";

// Google GeoLocation AIzaSyDjS2R7lNslhxlZ4QKXsO99qve0Ojt-YcU

@Injectable()
export class RestaurantService {



  private sdkDb;

  private restaurantRef;

  public  restaurants;


  private _currentRestaurant$:Subject<Restaurant> = new Subject<Restaurant>();




  setCurrentRestaurant(restaurant: Restaurant){
    this._currentRestaurant$.next(restaurant);
  }

  constructor(private db:AngularFireDatabase)
  {
    this.sdkDb = this.db.app.database().ref();
    this.restaurants = db.list('/restaurants');
    // this.restaurantRef = db.list('/


  }



  restaurantDisconnect(){
    this.restaurants.onDisconnect().set("Restaurants Disconected");
  }


  createNewRestaurant(restaurant: Restaurant, userId : string, email:string):Observable<any> {




    const restaurantToSave = Object.assign({},restaurant);

    const newRestaurantKey = this.restaurants.push({}).key;

    let stripeUser = Object.assign({},{"restaurantId":newRestaurantKey,"email": email,"restaurant_name":restaurant.restaurant,"created_by":userId});

    // console.log(stripeUser);

    let dataToSave = {};


    dataToSave["restaurants/"+ newRestaurantKey] = restaurantToSave;
    dataToSave["restaurantsPerUser/" + userId + '/' + newRestaurantKey+'/role'] = "admin-bp";
    dataToSave["usersPerRestaurant/" + newRestaurantKey + '/' + userId + '/role'] = "admin-bp";
    dataToSave["queue/tasks/acction/accounting/adduser/"] = stripeUser;

    // console.log(dataToSave);

    return this.firebaseUpdate(dataToSave);


  }




  saveRestaurant(restaurantP: Restaurant) : Observable <any> {


    let restaurantId = restaurantP.$key;

    const restaurantToSave = Object.assign({},restaurantP);

    delete(restaurantToSave.$key);

    let dataToSave = {};

    dataToSave["restaurants/"+ restaurantId ] = restaurantToSave;

    return this.firebaseUpdate(dataToSave);



  }



  enterCode(code:Code):Observable<any>{


    const codeToSave = Object.assign({}, code)

    // console.info(code);

    const newCodeleKey = this.sdkDb.child('codes').push().key;

    let dataToSave = {};

    dataToSave["codes/"+newCodeleKey] = codeToSave;

    return this.firebaseUpdate(dataToSave);
  }

  addMessage(message:any):Observable<any>{

    let thisMessage = Object.assign({},message);

    const newCodeleKey = this.sdkDb.child('messages').push().key;

    let dataToSave = {};

    dataToSave["messages/"+newCodeleKey] = thisMessage;

    return this.firebaseUpdate(dataToSave);

  }



  private firebaseUpdate(dataToSave: {}) {

    const subject = new Subject();

    this.sdkDb.update(dataToSave)
      .then(
        val =>{

          subject.next(val);
          subject.complete();

        },
        err =>{

          subject.error(err);
          subject.complete();

        }
      );

    return subject.asObservable();
  }



  getAllRestaurants():Observable<Restaurant[]>{
    return this.db.list('restaurants').map(Restaurant.fromJsonList);
  }





  findRestaurantByName(restaurantName:string){
    return this.db.list('restaurants',{
      query:{
        orderByChild: 'restaurant',
        equalTo: restaurantName
      }
    })
      .filter(results => results && results.length > 0)
      .map (results => results[0]);
}

/*

  getBillingInfo(restaurantKey:any) :Observable<PayeeCustomer>{

    // console.log("Getting Billing Info!" + restaurantKey);

   return this.db.list('stripe_customers',{
      query:{
        orderByChild:'restaurant_id',
        equalTo:restaurantKey
      }
    })
      // .do(result => console.log(result));
      .filter( result => result && result.length > 0)
      .map(result => PayeeCustomer.fromJson(result[0]))
     .first()


  }
*/



  getRestaurantsforUserAsAdmin(uidP:string):Observable<Restaurant[]>{


    const restaurantPerUser$ = this.db.list('restaurantsPerUser/'+uidP,{
      query:{

        orderByChild:'role',
        startAt:'admin',
        endAt:'admin-db'
      }
    })
      .filter(result => result && result.length > 0)
      .map ( result =>  result);

    const restaurant$ = restaurantPerUser$
      .map(restpu => restpu.map(rest => this.db.object('restaurants/' + rest.$key)))
      .flatMap(fbObj => Observable.combineLatest(fbObj));

    return restaurant$
  }


  gerCoordinatesFromAddress(address:{a:string}){

  }


  /*

    getRestaurantsforUserAsAdmin(uidP:string):Observable<Restaurant[]>{

      const restaurantPerUser$ = this.db.list('restaurantsPerUser/'+uidP)
        .filter(results => results && results.length > 0)
        .map (results => results);


      const restaurant$ = restaurantPerUser$
        .map(restpu => restpu.map(rest => this.db.created_by('restaurants/' + rest.$key)))
        .flatMap(fbObj => Observable.combineLatest(fbObj))

          return restaurant$
    }
  */


  getRestaurantByKey(restaurantKey: any) : Observable<Restaurant> {

    const restaurant$ = this.db.list('restaurants',{
      query:{
        orderByKey:true,
        equalTo:restaurantKey

      }
    })
      .filter(result => result && result.length > 0)
      .map (result => Restaurant.fromJson(result[0]));
      // .first();

    return restaurant$;

  }


 /* addSourcetoCustomer(cusrtomerId:string,sourceId:string):Observable<any>{

    let customerSource = Object.assign({},{"customerid":cusrtomerId,"sourceid":sourceId});

    let dataToSave = {};

    dataToSave["queue/tasks/acction/accounting/addsource/"] = customerSource;

    return this.firebaseUpdate(dataToSave);
  }*/

/*

  updateCustomerSource(customerid: string, sourceid: string, oldSourceid:string):Observable<any> {


    let customerSource = Object.assign({},{"customerid":customerid,"sourceid":sourceid,"oldsourceid":oldSourceid});

    let dataToSave = {};

    dataToSave["queue/tasks/acction/accounting/updatesource/"] = customerSource;

    console.log("Showing Customer Source for CC Edit");
    console.log(dataToSave);

    return this.firebaseUpdate(dataToSave);

  }
*/

/*
  updateCustomerEmail(customerid: string, email: string):Observable<any> {


    let customerSource = Object.assign({},{"customerid":customerid,"email":email});

    let dataToSave = {};

    dataToSave["queue/tasks/acction/accounting/updateemail/"] = customerSource;

    console.log("Showing Customer  for Email Edit");
    console.log(dataToSave);

    return this.firebaseUpdate(dataToSave);

  }
*/





}



// WEBPACK FOOTER //
// ./src/app/shared/services/restaurant/restaurant.service.ts